import React from 'react'

export default function Group({
  index = 0,
  children,
  groupNumber,
  header,
  newCategory = false,
}) {
  return (
    <>
      {(!(index % groupNumber) || newCategory) && header }
      {{
        ...children,
        props: {
          ...children.props,
          top: (!(index % groupNumber)) || newCategory,
          bottom: (index % groupNumber) === groupNumber - 1,
        },
      }}
    </>
  )
}
